import URLParser from '../URLParser'

const searchParamEqualsOne = (searchParam, ...expectedValues) => {
  return traffic => {
    const urlObject = new URLParser(traffic.url)
    return expectedValues.some(expValue => {
      const value = urlObject.searchParams.get(searchParam)
      return value !== null && value === expValue
    })
  }
}

export default searchParamEqualsOne



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/searchParamEqualsOne.js